import { getTextDirection } from 'ricos-content/libs/getTextDirection';

export const isTextDirectionRTL = (text) => getTextDirection(text) === 'rtl';
